import { ofType } from 'redux-observable';
import { Observable, EMPTY, concat, of, race } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

import { ModalService } from 'ui-components/services/modal-service';

import { HoldUntilModal } from '../../components/modals/hold-until-modal';
import { RemoveHoldModal } from '../../components/modals/remove-hold-modal';
import * as Actions from '../../store/hold-until/hold-until.actions';
import * as OrderActions from '../../store/orders/orders.actions';

const setHoldUntil$ = (action$, state, modalId, fulfillmentPlanIds, holdUntilDate) => {
  return concat(
    of(OrderActions.setHoldUntilDate(fulfillmentPlanIds, holdUntilDate)),
    race(
      action$.pipe(
        ofType(OrderActions.SET_HOLD_UNTIL_DATE_SUCCESS),
        take(1),
        mergeMap(() => {
          if (modalId) {
            ModalService.closeModalById(modalId);
          }

          return EMPTY;
        }),
      ),
      action$.pipe(
        ofType(OrderActions.SET_HOLD_UNTIL_DATE_FAILURE),
        take(1),
        mergeMap(() => {
          return of(Actions.setIsLoading(false));
        }),
      ),
    ),
  );
};
export const launchHoldUntilModal = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_HOLD_UNTIL_MODAL),
    mergeMap((action) => {
      let modalId;
      const { fulfillmentPlanIds } = action;
      return Observable.create((observer) => {
        modalId = ModalService.launchModal({
          component: HoldUntilModal,
          props: {
            ...action,
            placeOrdersOnHold: (holdUntilDate) => {
              observer.next(Actions.holdUntil(holdUntilDate));
              observer.complete();
            },
          },
          onClose: () => {
            observer.next(Actions.holdUntilModalClosed());
            observer.complete();
          },
        });
      }).pipe(
        mergeMap((nextAction) => {
          const { type, holdUntilDate } = nextAction;
          if (type !== Actions.HOLD_UNTIL) {
            return EMPTY;
          }

          return setHoldUntil$(action$, getState(), modalId, fulfillmentPlanIds, holdUntilDate);
        }),
      );
    }),
  );
};

export const launchRemoveHoldModal = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_REMOVE_HOLD_MODAL),
    mergeMap((action) => {
      let modalId;
      const { fulfillmentPlanIds } = action;
      return Observable.create((observer) => {
        modalId = ModalService.launchModal({
          component: RemoveHoldModal,
          props: {
            ...action,
            removeHold: () => {
              observer.next(Actions.holdUntil());
              observer.complete();
            },
          },
          onClose: () => {
            observer.next(Actions.holdUntilModalClosed());
            observer.complete();
          },
        });
      }).pipe(
        mergeMap((nextAction) => {
          if (nextAction.type !== Actions.HOLD_UNTIL) {
            return EMPTY;
          }

          return setHoldUntil$(action$, getState(), modalId, fulfillmentPlanIds, null);
        }),
      );
    }),
  );
};
